module.exports = __webpack_public_path__ + "img/harupyon.9897cd65.jpg";